import React from "react";
import { formatDate } from "@progress/kendo-intl";
import { dateFormat } from "../../utils/systemConstants.jsx";
import { getCellStyleAndValue } from "../../utils/pluginHelpers.jsx";
import { getUiCulture } from "../../utils/authHelper.jsx";

export default function GridDateCell({ dataItem, field, tdProps, style, className }) {
    let value = dataItem[field];
    const props = { style: style, ...tdProps };
    if (className)
        props.className = className;

    if (typeof value === "object") {
        if (value != null && value.id >= 0) {
            const plugin = getCellStyleAndValue(value);
            props.style = plugin.style;
            value = plugin.value;
        } else {
            value = null;
        }
    }

    return <td {...props}>
        {value ? formatDate(new Date(value), dateFormat, getUiCulture()) : null}
    </td>;
}